/**
 * Created by tiedong on 2017/6/7.
 */
import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'

const reducers = {}
const initialState = {
    seRequestId: '',
    chatMessages:[],
    chatMessagesArr:{},
    wxChatMsgHistory:[]
}


reducers[types.GET_CHATMESSAGE_HISTORY_FINISH] = {
    next(state, action) {
        return Object.assign({}, state, {
            chatMessages:action.payload.chatMessageHistory.messages,
            seRequestId : action.payload.chatMessageHistory.seRequestId
        })
    },
    throw(state, action) {
        return Object.assign({}, state, { loadError: true })
    }
}
reducers[types.GET_WXCHATMSG_HISTORY_FINISH]={
    next(state,action){
        return Object.assign({},state,{
            wxChatMsgHistory:action.payload.wxChatMsgHistory
        })
    },
    throw(state, action) {
        return Object.assign({}, state, { loadError: true })
    }
}

reducers[types.GET_CUSTOMER_CALL_RECORD] = (state,action)=> {
    if(action.error){
        return Object.assign({},state,{})
    }else {

        let chatMessagesArr = state.chatMessagesArr
        let chatMessages = action.payload.response.messages
        let requestId = action.payload.requestId
        if(chatMessages && chatMessages.length>0){
            chatMessagesArr[requestId] = chatMessages
        }

        return Object.assign({},state,{
            chatMessagesArr:Object.assign({},state.chatMessagesArr,chatMessagesArr)
        })

    }

 }

export default handleActions(reducers, initialState)
